<template>
  <div class="row">
    <div class="col p-3">
      <h1>HMO Transactions</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "HMOTransactions.vue"
};
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}
</style>